<template>
  <section class="nft-wrapper main-container search text-left pt-10 pb-20 px-5 md:px-10 mx-auto">
    <div class="mx-auto text-left mb-10 mt-10">
      <NftComponent />
    </div>
  </section>
</template>

<script>
import {defineComponent} from "vue";
import NftComponent from '@/components/common/NftComponent';

export default defineComponent({
  name: 'NftWrapper',
  components: {
    NftComponent,
  },
})
</script>

<style scoped>
.nft-wrapper {
  max-width: 90vw;
  min-height: calc(100vh - 270px);
}
</style>